import { Fragment } from 'react';

import { StyledFonts } from './fonts.styles';
import { StyledGlobal } from './global.styles';
import { StyledEffects } from './effects.styles';
import { StyledScrolls } from './scrolls.styles';

export const GlobalStyles = () => (
  <Fragment>
    <StyledFonts />
    <StyledGlobal />
    <StyledScrolls />
    <StyledEffects />
  </Fragment>
);
